var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"st-text"},[_c('IText',{attrs:{"icon":_vm.blok.icon,"title":_vm.blok.title,"titleH3":true,"content":_vm.blok.description,"inverted":false,"fontB1":true}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }